module.exports = __webpack_public_path__ + "img/xiangkuang.cd7ca691.png";